/**
 * 费用统计 API — GET /api/expenses/stats。
 */
import client from "./client";
import type { ExpenseStats } from "../types";

/** 费用统计查询参数。 */
export interface ExpenseStatsParams {
  month?: string;
  product_id?: string;
}

/** 获取费用统计数据。 */
export async function getExpenseStats(
  params?: ExpenseStatsParams,
): Promise<ExpenseStats> {
  return client.get<unknown, ExpenseStats>("/expenses/stats", { params });
}
